
const bracketMapName = new Map([
    ["mb1-bracket", "MB1 Bracket"],
    ["mb6", "MB6 Body Bracket"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "MB10 Mounting Bracket for the Rod end actuators"],
    ["mb1-p", "MB1-P Mounting Bracket for P-series Actuator"],
    ["mb3u", "MB3U Bracket"],
    ["mb3", "MB3 Bracket"],
    ["mb5",  "MB5 Bracket"],
    ["mb2", "MB2 Bracket"],
    ["mb-pb-premium-base-mounting-bracket", "P-series Base Mounting Bracket"],
    ["mb8-bracket", "MB8 Bracket"],
    ["mb14-bracket", "MB14 Bracket"],
    ["mb9-bracket", "MB9 Bracket"],
    ["mb6-p-bracket", "MB6-P body brackets for P-series actuators"],
    ["mb50u-mounting-bracket", "MB50U Mounting Bracket"],
    ["mb36sm", "MB36SM Mounting Bracket"],
    ["mb50", "MB50 Mounting Bracket"],
    ["pulley-lifting-cables-for-linear-actuators", "Pulley Lifting Cables for Linear Actuators"],
    ["mb36", "MB36 Mounting Bracket"],
    ["mb36c", "MB36C Mounting Clamp Bracket"],
    ["mb50c", "MB50C Mounting Clamp Bracket"],
    ["mb35-mounting-bracket", "MB35 Mounting Bracket"],
    ["mb7", "MB7 Micro Motor Bracket"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "MB-17 Mounting bracket For Super Duty Actuators"],
    ["mb18-mounting-brackets", "MB18 Mounting Brackets"]
]);